// extracted by mini-css-extract-plugin
module.exports = {"loading":"spinner_loading__2KloC","spin":"spinner_spin__2wyV-","simple_loading":"spinner_simple_loading__3XQ3n","pulse":"spinner_pulse__3tGbu"};